module.exports = __webpack_public_path__ + "static/img/2.fabb264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.jpg
// module id = AsW3
// module chunks = 1